import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { formatOrdinal } from "@/helpers/format.helpers";
import { faTrophy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface SubmissionPositionProps {
  readonly drop: ApiDrop;
}
export const SubmissionPosition: React.FC<SubmissionPositionProps> = t0 => {
  const $ = _c(6);
  const {
    drop
  } = t0;
  const rank = drop.rank;
  if (!rank) {
    return null;
  }
  let colorClasses;
  let t1;
  if ($[0] !== rank) {
    t1 = formatOrdinal(rank);
    $[0] = rank;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const rankText = t1;
  bb0: switch (rank) {
    case 1:
      {
        colorClasses = "tw-bg-yellow-500/10 tw-text-yellow-400 tw-border-yellow-500/20";
        break bb0;
      }
    case 2:
      {
        colorClasses = "tw-bg-iron-400/10 tw-text-iron-300 tw-border-iron-400/20";
        break bb0;
      }
    case 3:
      {
        colorClasses = "tw-bg-amber-600/10 tw-text-amber-500 tw-border-amber-600/20";
        break bb0;
      }
    default:
      {
        colorClasses = "tw-bg-iron-600/20 tw-text-iron-400 tw-border-iron-600/20";
      }
  }
  const t2 = `tw-flex tw-items-center tw-gap-1 tw-px-2 tw-py-0.5 tw-rounded tw-text-xs tw-font-semibold tw-border tw-border-solid tw-whitespace-nowrap tw-w-fit ${colorClasses}`;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FontAwesomeIcon icon={faTrophy} className="tw-size-2.5" />;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== rankText || $[4] !== t2) {
    t4 = <div className={t2}>{t3}{rankText}</div>;
    $[3] = rankText;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};